<template>
    <div>
        <vue-dropzone
                ref="myVueDropzone"
                id="dropzone"
                :options="dropzoneOptions"
                :useCustomSlot="true"
                v-on:vdropzone-success="uploadSuccess"
                v-on:vdropzone-error="uploadError"
                v-on:vdropzone-removed-file="fileRemoved"
                v-on:vdropzone-thumbnail="fileAdded"

        >
            <div class="dropzone-custom-content">
                <div class="text-center">
                    <h5 class="text-smanel-dark-purple"> <i class="fas fa-file-alt fa-2x"></i></h5>
                </div>
                <h5 class="dropzone-custom-title text-smanel-dark-purple py-2">Drag & Drop</h5>

                <div class="text-center"><a class="btn btn-outline-smanel-dark-purple" href="#">Choose File</a>
                    <p v-if="description !==''"><small>{{ description }}</small></p>
                    <p v-else><small>Max file size 2MB, only .xls allowed</small></p>
                </div>
            </div>
        </vue-dropzone>
        <input name="uploaded_file" ref="input" v-model="fileuploaded" id="filename" type="hidden" value="">
    </div>
</template>

<script>
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    export default {
        components: {
            vueDropzone: vue2Dropzone
        },
        props:['description'],
        data() {
            return {
                dropzoneOptions: {
                    url: "/api/files",
                    addRemoveLinks: true,
                    maxFiles: 1,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                },
                fileName: '',
                fileuploaded: ''

            };
        },
        methods: {
            uploadSuccess(file, response) {
                console.log('File Successfully Uploaded with file name: ' + response.file);
                this.fileName = response.file;
                this.fileuploaded = response.file;


            },
            uploadError(file, message) {
                console.log('An Error Occurred');
            },
            fileAdded(file){




            },
            fileRemoved() {}
        }
    };
</script>